import { useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useAuth } from '../../auth/AuthContext';
import { useFeedback } from '../../hooks/useFeedback';
import { getApiErrorMessage } from '../../utils/apiError';
import './LoginPage.css';

const LoginPage = () => {
  const [loginForm, setLoginForm] = useState({ login: '', password: '' });
  const { showError, feedbackNode } = useFeedback();
  const { login, isAuthenticated, loading } = useAuth();
  const navigate = useNavigate();

  if (!loading && isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      await login(loginForm.login, loginForm.password);
      navigate('/');
    } catch (err) {
      showError(getApiErrorMessage(err, 'Неверный логин или пароль'));
    }
  };

  return (
    <div className="login-page">
      {feedbackNode}
      <div className="login-card">
        <img src="/plane.png" alt="Самолёт" className="login-icon" />
        <h1>Бортовой Журнал</h1>
        <p className="login-subtitle">Вход в систему</p>
        <form onSubmit={handleSubmit}>
          <input
            type="text"
            placeholder="Логин"
            value={loginForm.login}
            onChange={(e) => setLoginForm({ ...loginForm, login: e.target.value })}
          />
          <input
            type="password"
            placeholder="Пароль"
            value={loginForm.password}
            onChange={(e) =>
              setLoginForm({ ...loginForm, password: e.target.value })
            }
          />
          <button type="submit">Войти</button>
        </form>
        <p className="login-footer">
          Нет клуба? <a href="/register">Зарегистрировать</a>
        </p>
      </div>
    </div>
  );
};

export default LoginPage;
